import { weekDayMap, weekDaySymbol, fromWord, andWord, toWord, fullWeek } from './job-shifts.mocks';
import { weekdayMapType, fullWeekType } from './job-shifts.types';

const workDaysSorted = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

// -->  fn to get aggregated weekday string
const aggregateWorkdayFn = (workDay: string[], invert = false) => {
  let newList = [...workDay].sort((a, b) => workDaysSorted.indexOf(a) - workDaysSorted.indexOf(b));

  if (invert) newList = weekDaySymbol.filter((v) => ![...workDay].includes(v));
  const len = newList.length;
  if (!len) return '';
  const firstWeek = newList[0] as weekdayMapType;
  if (len === 1) return `${capitalizeFirstLetter(weekDayMap[firstWeek])}`;
  const lastDay = newList[len - 1] as weekdayMapType;
  if (len === 2) return `${capitalizeFirstLetter(weekDayMap[firstWeek])} ${andWord} ${weekDayMap[lastDay]}`;
  const weekNumbers: number[] = newList.map((v) => fullWeek[v as weekdayMapType]);
  if (isConsecutiveNumbers(weekNumbers)) return `${fromWord} ${weekDayMap[firstWeek]} a ${weekDayMap[lastDay]}`;
  const aggString = generateConsecutiveString(weekNumbers);
  const leanString = removeUnwantedCommas(aggString);
  return capitalizeFirstLetter(leanString);
};
// --> fn to check if the number is consecutive or not
const isConsecutiveNumbers = (weekNumbers: number[]) =>
  Boolean(weekNumbers.reduce((prev: number, curr: number) => (prev ? (prev + 1 === curr ? curr : 0) : 0)));
// --> fn to reverse object
const reverseObject = (data: fullWeekType) =>
  Object.fromEntries(Object.entries(data).map(([key, value]) => [value, key]));
// --> fn to get a string of consecutive array
const generateConsecutiveString = (weekNumbers: number[]) => {
  const consecutiveRange = consecutiveRanges(weekNumbers);
  const reverseWeekNumber: { [k: string]: string } = reverseObject(fullWeek);
  const aggregatedString = `${consecutiveRange.map((x, i, list) => {
    const prefixAndWord = list.length - 1 === i ? andWord : '';
    if (Array.isArray(x)) {
      const initialWeek = weekDayMap[reverseWeekNumber[x[0]] as weekdayMapType];
      const lastWeek = weekDayMap[reverseWeekNumber[x[x.length - 1]] as weekdayMapType];
      const isLengthGreaterEqualThree = x.length >= 3;
      const prefixFromWord = isLengthGreaterEqualThree ? fromWord : '';
      const midWord = isLengthGreaterEqualThree ? toWord : andWord;
      return ` ${prefixAndWord} ${prefixFromWord} ${initialWeek} ${midWord} ${lastWeek}`;
    }
    return ` ${prefixAndWord} ${weekDayMap[reverseWeekNumber[x] as weekdayMapType]}`;
  })}`;
  return aggregatedString.trim();
};
// --> fn to get consecutive array of string
const consecutiveRanges = (a: number[]) => {
  let length = 1;
  const list: (number | number[])[] = [];
  const iterateNumbersToRange = (min: number, max: number) => Array.from({ length: max - min + 1 }, (_, i) => min + i);
  if (a.length === 0) return list;
  for (let i = 1; i <= a.length; i++) {
    if (i === a.length || a[i] - a[i - 1] !== 1) {
      if (length === 1) list.push(a[i - length]);
      else {
        const consecutiveRange: number[] = iterateNumbersToRange(Number(a[i - length]), Number(a[i - 1]));
        list.push(consecutiveRange);
      }
      length = 1;
    } else {
      length++;
    }
  }
  return list;
};

const removeUnwantedCommas = (str: string) => {
  return str.replace(', e', ' e');
};

const capitalizeFirstLetter = (string: string) => string[0].toUpperCase() + string.slice(1);
export { aggregateWorkdayFn };
